class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("menulink:click", (event) => {
      if (this.classList.contains("state--active")) {
        this.hide();
      } else {
        this.show();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.classList.contains("state--active")) {
        this.hide();
      }
    });
  }

  show() {
    this.opener = document.activeElement;

    requestAnimationFrame(() => {
      this.classList.add("state--active");
      this.querySelector(".menu-content")?.focus({ preventScroll: true });
    });
  }

  hide() {
    this.classList.remove("state--active");

    if (this.opener && this.opener.isConnected) {
      this.opener.focus({ preventScroll: true });
    }

    this.opener = null;
  }
}

customElements.define("menu-drawer", MenuDrawer);

class MenuOverlay extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("menu-drawer").hide();
    });
  }
}

customElements.define("menu-overlay", MenuOverlay);


class MenuClose extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("menu-drawer").hide();
    });
  }
}

customElements.define("menu-close", MenuClose);
